var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Security / Logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Security-/-Logout",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout-Box-Line",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99999991,18.0000002 L5.99999991,18.0000002 L5.99999991,20.0000002 L17.9999999,20.0000002 L17.9999999,4.00000015 L5.99999991,4.00000015 L5.99999991,6.00000015 L3.99999991,6.00000015 L3.99999991,3.00000015 L3.99999991,3.00000015 C3.99999991,2.44771515 4.447715,2.00000015 4.99999991,2.00000015 L18.9999999,2.00000015 L18.9999999,2.00000015 C19.552285,2.00000015 19.9999999,2.44771515 19.9999999,3.00000015 L19.9999999,21.0000002 L19.9999999,21.0000002 C19.9999999,21.5522852 19.552285,22.0000002 18.9999999,22.0000002 L4.99999991,22.0000002 L4.99999991,22.0000002 C4.44771491,22.0000002 3.99999991,21.5522852 3.99999991,21.0000002 C3.99999991,21.0000002 3.99999991,21.0000002 3.99999991,21.0000002 L3.99999991,18.0000002 L3.99999991,18.0000002 Z M6,11 L13,11 L13,13 L6,13 L6,16 L1,12 L6,8 L6,11 Z",
    id: "Shape",
    fillOpacity: 0.64,
    fill: "#191923",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.487b2cbd75b5b8455ae1b6d4267bb836.svg";
export { ForwardRef as ReactComponent };